import ClientProfileConfiguration from "../pages/client-profile/clientProfileConfiguration";
import ClientProfileManageCustomAttributes from "../pages/client-profile/clientProfileManageCustomAttributes";
import PriControlGroupCategories from "../pages/client-profile/clientProfilePriControlGroup";
import PriControlGroupCategoriesPopulation from "../pages/client-profile/clientProfilePriControlGroupPopulation";
import Identifiers from "../pages/client-profile/clientProfileIdentifiers";
import ClientProfileThirdParties from "../pages/client-profile/clientProfileThirdParties";
import Waldo from "../pages/waldo";
import MediaSearch from "../pages/mediaSearch";
import PRIClientProfilePage from "../pages/priClientProfile";

import PriSettingsPage from "../pages/priSettingsPage";
import PriSettingsGeneralPage from "../pages/pri-settings/priSettingsGeneralPage";
import PriSettingsGoogleCustomSearchEngine from "../pages/pri-settings/priSettingsGoogleCustomSearchEngine";
import PriSettingsGoogleCustomSearchEngineUrl from "../pages/pri-settings/priSettingsGoogleCustomSearchEngineUrl";
import PriSettingsPublicListedCompany from "../pages/pri-settings/priSettingsPublicListedCompany";
import PriSettingsDueDiligenceCategories from "../pages/pri-settings/priSettingsDueDiligenceCategories";
import PriSettingsStopWordsPage from "../pages/pri-settings/priSettingsStopWordsPage";
import PriSettingsDepartmentsPage from "../pages/pri-settings/priSettingsDepartmentsPage";
import PriSettingsBenchmarkThirdParties from "../pages/pri-settings/priSettingsBenchmarkThirdParties.vue";
import PriSettingsControlGroup from "../pages/pri-settings/priSettingsControlGroup.vue";
import PriSettingsControlGroupPopulation from "../pages/pri-settings/priSettingsControlGroupPopulation.vue";

import PriSimulation from "../pages/pri-simulation";
import ClientsVueContainer from "../containers/ClientsVueContainer";
import PriSearchesContainer from "../containers/PriSearchesContainer";
import PriSearchesControlGroupContainer from "../containers/PriSearchesControlGroupContainer";
import PriSearchesControlGroupDetailList from "../containers/PriSearchesControlGroupDetailListContainer";
import PriSearchContainer from "../containers/PriSearchContainer";
import PriSearchControlGroupContainer from "../containers/PriSearchControlGroupContainer";
import PriControlGroupPopulation from "../containers/PriControlGroupPopulation";
import PRICreation from "../pages/pri-creation";
import PriSettingsConfigurablePri from "../pages/pri-settings/priSettingsConfigurablePri";

export default [
  {
    path: "/",
    name: "home",
    props: true,
    component: PriSearchesControlGroupContainer,
    meta: { requiresAuth: true },
  },
  {
    path: "/waldo",
    name: "waldo",
    component: Waldo,
    meta: { requiresAuth: true },
  },

  {
    path: "/media-search",
    name: "mediasearch",
    component: MediaSearch,
    meta: { requiresAuth: true },
  },

  {
    path: "/pri-client-profile/:id",
    name: "priClientProfilePage",
    props: true,
    component: PRIClientProfilePage,
    children: [
      {
        name: "configuration",
        path: "configuration",
        component: ClientProfileConfiguration,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "thirdParties",
        path: "thirdparties",
        props: true,
        component: ClientProfileThirdParties,
        meta: { requiresAuth: true },
      },
      {
        name: "manageCustomAttributes",
        path: "tpi-custom-attributes",
        component: ClientProfileManageCustomAttributes,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "PriControlGroupCategories",
        path: "pri-control-group-categories",
        component: PriControlGroupCategories,
        meta: { requiresAuth: true },
      },
      {
        name: "PriControlGroupCategories",
        path: "pri-control-group-categories-population",
        component: PriControlGroupCategoriesPopulation,
        meta: { requiresAuth: true },
      },
      {
        name: "Identifiers",
        path: "identifiers",
        component: Identifiers,
        meta: { requiresAuth: true },
      },
    ],
    meta: { requiresAuth: true },
  },

  {
    path: "/pri-settings",
    name: "PriSettingsPage",
    props: true,
    component: PriSettingsPage,
    children: [
      {
        name: "configurable-pri",
        path: "configurable-pri",
        component: PriSettingsConfigurablePri,
        meta: { requiresAuth: true },
      },
      {
        name: "PriSettingsGeneralPage",
        path: "general-page",
        component: PriSettingsGeneralPage,
        meta: { requiresAuth: true },
      },
      {
        name: "GoogleCustomSearchEngine",
        path: "google-custom-search-engine",
        component: PriSettingsGoogleCustomSearchEngine,
        meta: { requiresAuth: true },
      },
      {
        name: "GoogleCustomSearchEngineUrl",
        path: "google-custom-search-engine-url",
        component: PriSettingsGoogleCustomSearchEngineUrl,
        meta: { requiresAuth: true },
      },
      {
        name: "PublicListedCompany",
        path: "public-listed-company",
        component: PriSettingsPublicListedCompany,
        meta: { requiresAuth: true },
      },
      {
        name: "DueDiligenceCategories",
        path: "due-diligence-categories",
        component: PriSettingsDueDiligenceCategories,
        meta: { requiresAuth: true },
      },
      {
        name: "PriSettingsStopWordsPage",
        path: "filtered-keywords",
        component: PriSettingsStopWordsPage,
        meta: { requiresAuth: true },
      },
      {
        name: "PriSettingsDepartmentsPage",
        path: "departments-page",
        component: PriSettingsDepartmentsPage,
        meta: { requiresAuth: true },
      },
      {
        name: "PriSettingsControlGroup",
        path: "control-group-categories",
        component: PriSettingsControlGroup,
        meta: { requiresAuth: true },
      },
      {
        name: "PriSettingsControlGroupPopulation",
        path: "pri-control-group-categories-population",
        component: PriSettingsControlGroupPopulation,
        meta: { requiresAuth: true },
      },
      {
        name: "PriSettingsBenchmarkThirdParties",
        path: "benchmark-third-parties",
        props: true,
        component: PriSettingsBenchmarkThirdParties,
        meta: { requiresAuth: true },
      },
    ],
  },

  // -----------------PRI
  {
    path: "/pri-simulation",
    name: "priSimulation",
    component: PriSimulation,
    meta: { requiresAuth: true },
  },
  {
    path: "/pri-clients",
    name: "priClients",
    component: ClientsVueContainer,
    meta: { requiresAuth: true },
  },

  {
    path: "/pri-searches",
    name: "priSearches",
    component: PriSearchesContainer,
    meta: { requiresAuth: true },
  },

  {
    path: "/pri-searches-control-groups",
    name: "priSearchesControlGroup",
    component: PriSearchesControlGroupContainer,
    meta: { requiresAuth: true },
  },
  {
    path: "/pri-searches-control-group/:id",
    name: "priSearchesControlGroupDetailList",
    component: PriSearchesControlGroupDetailList,
    meta: { requiresAuth: true },
    props: true,
  },

  {
    path: "/pri-search/:searchId",
    name: "priSearchDetail",
    component: PriSearchContainer,
    meta: { requiresAuth: true },
  },

  {
    path: "/pri-search/control-group/:searchId",
    name: "priSearchControlGroupDetail",
    component: PriSearchControlGroupContainer,
    meta: { requiresAuth: true },
  },

  {
    name: "PriControlPopulation",
    path: "/pri-control-group-population",
    component: PriControlGroupPopulation,
    props: true,
    meta: { requiresAuth: true },
  },

  {
    path: "/pri-creation",
    name: "pri-creation",
    component: PRICreation,
    meta: { requiresAuth: true },
  },
];
